import { render, staticRenderFns } from "./EditorHeaderButtonDownload.vue?vue&type=template&id=03f28d21&scoped=true"
import script from "./EditorHeaderButtonDownload.vue?vue&type=script&lang=js"
export * from "./EditorHeaderButtonDownload.vue?vue&type=script&lang=js"
import style0 from "./EditorHeaderButtonDownload.vue?vue&type=style&index=0&id=03f28d21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f28d21",
  null
  
)

export default component.exports